<template>
  <div v-if="payload" class="is-flex">
    <div
      v-if="showApplicant"
      @mouseover="onMouseOver(showApplicant)"
      @mouseleave="onMouseLeave"
      class="mx-5">
      <router-link
        :to="{
          name: 'admin-applicants',
          query: { show_id: showApplicant.resource_id }
        }"
        class="blue_text link-entity">
        <u>{{ showApplicant.display_text }}</u>
      </router-link>
    </div>
    <div
      v-if="showPosition"
      @mouseover="onMouseOver(showPosition)"
      @mouseleave="onMouseLeave"
      class="mx-5">
      <router-link
        :to="{
          name: 'company-positions',
          query: {
            company_id: showPosition.company.resource_id,
            show_id: showPosition.id
          }
        }"
        class="blue_text link-entity">
        <u>{{ showPosition.display_text }}</u>
      </router-link>
    </div>
    <div
      v-if="showCompany"
      @mouseover="onMouseOver(showCompany)"
      @mouseleave="onMouseLeave"
      class="mx-5">
      <router-link
        :to="{
          name: 'admin-companies',
          query: { show_id: showCompany.user_id }
        }"
        class="blue_text link-entity">
        <u>{{ showCompany.display_text }}</u>
      </router-link>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'TableCellLiteResources',
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters('modals', ['findModal']),
    showApplicant () {
      if (!this.payload) return null
      const applicant = this.payload.resources.applicant
      if (!applicant) return null
      const params = {
        modal_name: 'ApplicantInfo',
        display_text: `${applicant.first_name} ${applicant.last_name} ${this.$utils.getVetted(applicant)}`
      }
      return { ...applicant, ...params }
    },
    showPosition () {
      if (!this.payload) return null
      const position = this.payload.resources.position
      if (!position) return null
      const params = {
        modal_name: 'ModalPosition',
        modal_width: 1500,
        display_text:
          position.title + (position.is_discrete ? ' (DISCRETE)' : '')
      }
      return { ...position, ...params }
    },
    showCompany () {
      if (!this.payload) return null
      const company = this.payload.resources.company
      if (!company) return null
      const params = {
        modal_name: 'CompanyInfo',
        display_text: this.payload.resources.company.name
      }
      return { ...this.payload.resources.company, ...params }
    }
  },
  methods: {
    ...mapMutations('modals', ['remove', 'create']),
    onMouseOver (data) {
      this.create({
        designator: 'link-entity-resource-modal',
        resource_type: data.resource_type,
        resource_id: data.resource_id,
        component_name: data.modal_name,
        data: data,
        modal_title: data.display_text
      })
    },
    onMouseLeave () {
      const modal = this.findModal({
        type: 'designator',
        value: 'link-entity-resource-modal'
      })
      this.remove(modal)
    }
  }
}
</script>
<style scoped>
.link-entity {
  color: #3273dc !important;
}
</style>
